import { css } from "@emotion/react";

import { TASK_OVERVIEW_STATUSES } from "../../types";
import SingleStatus from "./SingleStatus";
import { LegendProps } from "./types";

const Legend = ({ customStyles }: LegendProps) => {
    return (
        <div
            css={css({
                display: "flex",
                columnGap: "16px",
                padding: "4px 0",
                ...customStyles
            })}
        >
            <SingleStatus status={TASK_OVERVIEW_STATUSES.Completed} />
            <SingleStatus status={TASK_OVERVIEW_STATUSES.CompletedWithErrors} />
            <SingleStatus status={TASK_OVERVIEW_STATUSES.Failed} />
        </div>
    );
};

export { Legend };
